import React from 'react'
import { IPropsTickets, ISellCreditTicket } from '../utils/interfaceTickets'
import { formatearFecha, formatosFecha } from 'util/formatDate'

const PrincipalInfoTicket = ({ data }: IPropsTickets) => {

    data = data as ISellCreditTicket

    return (
        <>
            <div className='receipt__separator'></div>
            <div className='receipt__separator'></div>

            <table>
                <thead>
                    <tr>
                        <th className="receipt__table__header" style={{ width: 'calc(100%/4)' }}></th>
                        <th className="receipt__table__header" style={{ width: 'calc(100%/4)' }}></th>
                        <th className="receipt__table__header" style={{ width: 'calc(100%/4)' }}></th>
                        <th className="receipt__table__header" style={{ width: 'calc(100%/4)' }}></th>
                    </tr>
                </thead>

                <tbody>
                    <tr>
                        <td colSpan={2}>REMISION NRO:</td>
                        <td className="receipt__table__cell" colSpan={2}>{data.consecutivo_factura}</td>
                    </tr>
                    <tr>
                        <td colSpan={2}>FECHA:</td>
                        <td className="receipt__table__cell" colSpan={2}>{formatearFecha(data.fecha_generacion, formatosFecha.completa2, true)}</td>
                        {/* <td ></td> */}
                    </tr>
                    <tr>
                        <td colSpan={2}>TURNO:</td>
                        <td className="receipt__table__cell" colSpan={2}>{data.id_jornada}</td>
                    </tr>
                    <tr>
                        <td colSpan={2}>PROMOTOR:</td>
                        <td className="receipt__table__cell text__ellipsis w__ellipsis__medium" colSpan={2}>{data.promotor}</td>
                    </tr>
                    <tr>
                        <td className='receipt__table__cell'>ISLA: {data.isla}</td>
                        <td className='receipt__table__cell'>POS: {data.isla}</td>
                        <td className='receipt__table__cell'>CARA: {data.cara}</td>
                        <td className='receipt__table__cell'>MANGUERA: {data.manguera}</td>
                    </tr>
                </tbody>
            </table>
        </>
    )
}

export default PrincipalInfoTicket